import { settingOn } from '@/lib/settings';
import { useLocations } from '@/stores/locations';

/**
 * Whether city pages draw the Venues map (`venues.enabled`). Settings arrive on the locations
 * response into module state, which re-renders nothing, so this subscribes to that response's
 * status: whatever read the compiled default before it landed reads the live value after.
 */
export function useVenuesEnabled(): boolean {
  useLocations((state) => state.status);
  return settingOn('venues.enabled');
}
